"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverMenuExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/popover-menu/examples/index.ts';
var PopoverMenuExample = /** @class */ (function () {
    function PopoverMenuExample() {
        this.closeOnClick = true;
    }
    PopoverMenuExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.PopoverMenu, {
                closeOnContentClick: this.closeOnClick,
                content: [
                    (0, mithril_1.default)(_1.MenuItem, {
                        iconLeft: _1.Icons.COPY,
                        label: 'Copy'
                    }),
                    (0, mithril_1.default)(_1.MenuItem, {
                        iconLeft: _1.Icons.EDIT_2,
                        label: 'Edit'
                    }),
                    (0, mithril_1.default)(_1.MenuItem, {
                        iconLeft: _1.Icons.SETTINGS,
                        label: 'Settings'
                    }),
                    (0, mithril_1.default)(_1.MenuDivider),
                    (0, mithril_1.default)(_1.MenuItem, {
                        iconLeft: _1.Icons.TRASH_2,
                        label: 'Delete',
                        intent: 'negative'
                    })
                ],
                menuAttrs: { size: this.size },
                trigger: (0, mithril_1.default)(_1.Button, { iconLeft: _1.Icons.SETTINGS })
            })
        ]);
    };
    PopoverMenuExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Close on select',
                onchange: function () { return _this.closeOnClick = !_this.closeOnClick; },
                checked: this.closeOnClick
            })
        ];
    };
    return PopoverMenuExample;
}());
exports.PopoverMenuExample = PopoverMenuExample;
